<template>
  <div :class="['container', configObj.ifShow ? 'containerShow' :'containerHide']">
    <div class="dialogCon">
      <a class="closeBtn" @click="closeBtnClick"></a>

      <!--<img class="stateImg" :src="configObj.ifSuccess ? imgPath1 : imgPath0">-->
      <img class="stateImg"
           :src="configObj.ifSuccess ? require('@/assets/success-pic.png') : require('@/assets/failed-pic.png')">
      <p :class="['title', configObj.ifSuccess ? '' : 'red']">{{configObj.ifSuccess ?
        (configObj.type == 0 ? '注册成功' : '新密码设置成功') :
        (configObj.type == 0 ? '注册失败' : '新密码设置失败')}}
      </p>

      <div v-if="configObj.ifSuccess">
        <p class="bottom action">系统 {{time}} 秒后自动跳转到认证申请页</p>
        <p class="bottom margin11">如无跳转，<span class="fontStyle underLine goLogin"
                                              @click="jump2Approve">点此跳转</span></p>
      </div>
      <div v-else class="failCon">
        <p class="bottom reason">原因：{{configObj.message}}</p>
        <p class="fontStyle underLine regAgain" @click="registerAgain">重新注册</p>
        <P class="bottom bottomNav">联系客服<a
          :href="'http://wpa.qq.com/msgrd?v=3&uin='+kfqq+'&site=qq&menu=yes'"
          target="_blank"
          class="fontStyle underLine qqStyle">{{kfqq}}</a><span
          class="fontStyle telStyle">{{tel}}</span></P>
      </div>
    </div>
  </div>
</template>

<script>
  import Base64 from '@/utils/base64'

  export default {
    name: 'FDialog',
    data () {
      return {
        // 客服的qq
        kfqq: this.$global.kfqq,
        // 联系电话
        tel: this.$global.tel,
        configObj: Object
        , timer: 0
        , time: 3
      }
    }
    , props: {
      config: Object,
      // default: function () {
      //   return {
      //     ifSuccess: true
      //     , type: '0'
      //     , ifShow: 0
      //     , message: '网络链接失败！'
      //   }
      // }
    }
    , methods: {
      closeBtnClick () {
        this.closeDialog()
      },

      // 关闭弹窗
      closeDialog () {
        this.configObj.ifShow = 0
        // 关闭轮询
        clearInterval(this.timer)
      }

      // 重新注册
      , registerAgain () {
        this.closeDialog()
      }

      // 跳转到认证页
      , jump2Approve () {
        this.$router.push({
          path: '/approve'
        })
        this.configObj.ifShow = 0
      }
      // 跳转到首页
      , jump2Index () {
        let params = {
          UserName: this.configObj.username,
          PassWord: this.configObj.pwd
        }
        this.$axios.post('UserManager/UserLogin', params)
          .then((res) => {
            let data = res.data
            if (data.isError == 'False') {
              this.afterLoginFuc(data.result[0])
            } else {
              this.$message({
                message: '登录失败!请刷新重试'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.$message({
              message: '登录失败!请刷新重试'
              , type: 'warning'
            })
          })
      }
      // 登录后调用的方法
      , afterLoginFuc (result) {
        if (result.UserType == '永久用户') {
          window.location.href = "/User/Index";
        } else if (result.UserType == '未认证用户' || result.UserType == '试用期过期用户' || result.UserType == '试用用户') { // 未认证的用户
          var config = 'username=' + result.UserName + '&nsrsbh=' + (result.Nsrsbh == null ? '' : result.Nsrsbh)
            , encodeStr = base64encode(encodeURI(config))
            // 先测试地址
            , finalUrl = '/RiskStaticFiles/vue/#/approve?' + encodeStr
          ;
          console.log(config, encodeStr)
          window.location.href = finalUrl;
        }else if(result.UserType == '后台用户'){//
          console.log(result)
          window.location.href = "/RiskStaticFiles/vue/#/Authentication?name=" + result.name;
          // window.location.href = "/#/Authentication?name=" + result.name;
        }
      }
    }
    , created () {
      this.configObj = this.config
    }
    , watch: {
      'configObj.ifShow': function (newData, oldData) {
        let that = this
        if (newData == 1) {
          that.timer = setInterval(function () {
            that.time--
            if (that.time == 0) {
              clearInterval(that.timer)
              // 如果为注册页面, 则跳入认证申请页
              if (that.configObj.type == 0 && that.configObj.ifSuccess) {
                that.jump2Approve()
              } else if (that.configObj.type == 1 && that.configObj.ifSuccess) {
                that.jump2Index()
              }
            }
          }, 1000)
        }
      }
    }
  }
</script>

<style scoped>
  .container {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.24);
    opacity: 0;
  }

  .dialogCon {
    position: absolute;
    width: 540px;
    height: 360px;
    margin: auto;
    background: #ffffff;
    border-radius: 2px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*cubic-bezier(.05, .45, .51, 2.91)*/
    transition: transform .15s linear;
    transform: scale(1.1);
  }

  .closeBtn {
    position: absolute;
    display: block;
    background: url("../assets/close_off.png") no-repeat center;
    width: 32px;
    height: 32px;
    right: 0;
    top: 0;
    cursor: pointer;
  }

  .closeBtn:hover {
    background: url("../assets/close_on.png") no-repeat center;
  }

  .stateImg {
    display: block;
    width: 80px;
    height: 80px;
    margin: 71px auto 0;
  }

  .title {
    height: 58px;
    line-height: 58px;
    margin-top: 8px;
    font-size: 20px;
    color: #5599FF;
    text-align: center;
    font-weight: 600;
  }

  .red {
    color: #FF4D4D;
  }

  .fontStyle {
    font-size: 13px;
    color: #5599FF;
    text-align: center;
  }

  .reason {

  }

  .underLine {
    text-decoration: underline;
    cursor: pointer;
  }

  .regAgain {
    margin-top: 23px;
    font-size: 14px;
    text-align: center;
  }

  .bottom {
    font-size: 14px;
    color: #838383;
    text-align: center;
  }

  .bottomNav {
    margin-top: 29px;
  }

  .qqStyle {
    margin-left: 19px;
    padding-left: 20px;
    background: url("../assets/qq_bg.png") no-repeat left center;
  }

  .telStyle {
    margin-left: 24px;
    padding-left: 20px;
    background: url("../assets/tel_bg.png") no-repeat left center;
  }

  .action {
    margin-top: 19px;
    font-size: 16px;
  }

  .margin11 {
    margin-top: 11px;
  }

  .containerHide .dialogCon {
    transform: scale(1.1);
  }

  .containerHide {
    opacity: 0;
  }

  .containerShow {
    opacity: 1;
  }

  .containerShow .dialogCon {
    transform: scale(1);
  }

</style>



// WEBPACK FOOTER //
// src/components/FDialog.vue